import { Link } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { useConfig } from 'src/core/config';

const LogoWrapper = styled(Link)(
  ({ theme }) => `
        color: ${theme.palette.text.primary};
        padding: ${theme.spacing(0, 1, 0, 0)};
        display: flex;
        text-decoration: none;
        font-weight: ${theme.typography.fontWeightBold};
`
);

interface LogoProps {
  /** Custom link destination. Defaults to dashboard route from config */
  to?: string;
  /** Logo width. Defaults to 210 */
  width?: number;
}

export default function Logo({ to, width = 210 }: LogoProps) {
  const { name, assets } = useConfig();
  const linkTo = to || '/';

  return (
    <LogoWrapper to={linkTo}>
      <img
        alt={`${name} Logo`}
        width={width}
        src={assets.logo}
      />
    </LogoWrapper>
  );
}

